import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { ConversionSystem, toImperial, Units } from "@library";

@Pipe({
    name: 'convertValue',
})
export class ConvertValuePipe implements PipeTransform {
    constructor(
        private _decimalPipe: DecimalPipe,
    ) {}

    transform(value: any, unit: Units, system: ConversionSystem | null = ConversionSystem.METRIC, digitsInfo: string = '1.1-2', isValue: boolean = true) : string {
        if (value === null || value === undefined || isNaN(value)) return '-';

        let displayValue = value;
        let displayUnit = unit;

        if (system === ConversionSystem.IMPERIAL) {
            const converted = toImperial(value, unit);
            displayValue = converted.value;
            displayUnit = converted.unit as any;
        }

        if (!isValue) return displayUnit;

        return this._decimalPipe.transform(displayValue, digitsInfo);
    }
}